module.exports = __webpack_public_path__ + "fontawesome-webfont.25a32416abee198dd821.eot";


//////////////////
// WEBPACK FOOTER
// ./~/components-font-awesome/fonts/fontawesome-webfont.eot?v=4.6.3
// module id = 232
// module chunks = 2